export default "__VITE_ASSET__8927b927__"